'use strict';

define('vb/private/translations/bundlesModel',[
  'vb/private/constants',
  'vb/private/log',
  'vb/private/translations/bundleDefinition',
  'vb/private/translations/bundleV2Definition',
  'vb/binding/expression',
  'ojs/ojconfig',
], (Constants, Log, BundleDefinition, BundleV2Definition, Expression, ojConfig) => {
  const logger = Log.getLogger('vb/private/translations/bundlesModel');

  // we use the convention that V2 files are named "*-i18n".
  // requireJS requires the .js when the path includes protocol, and the file is not in a bundle.
  // Otherwise, the JS must be omitted.
  const REGEXP_V2 = /-i18n(\.js)?$/;
  /**
   *
   */
  class BundlesModel {
    /**
     * create an array of (non-null) BundleDefinition.
     * Falsy paths should be ignored/skipped (VBS-2097)
     *
     * @param metadata
     * @param runtimeEnv
     * @param requirePath
     * @param options {isUnrestrictedRelative, replacementValues}
     */
    constructor(metadata = {}, runtimeEnv, requirePath = '', options = {}) {
      this.log = logger;
      this.relativePath = requirePath;
      this.bundleMap = {};
      this.runtimeEnvironment = runtimeEnv;

      // using JET to get locale
      const locale = ojConfig.getLocale();

      this.bundleDefinitionsMap = {};

      this.bundleDefinitions = Object.keys(metadata || {})
        .map((name) => {
          const decl = metadata[name];

          const path = decl && decl.path && Expression
            .getEvaluatedSafe(decl.path, {
              [Constants.ContextName.INIT_PARAMS]: options.initParams || {},
            });

          if (path) {
            const Clazz = (this.isV2(path)) ? BundleV2Definition : BundleDefinition;

            const def = new Clazz(name, path, decl, locale, requirePath, options);
            this.bundleDefinitionsMap[name] = def;
            return def;
          }

          logger.error('No path declared for translation bundle', name);
          return null;
        })
        .filter((bundle) => !!bundle); // remove nulls
    }

    /**
     * path (file name) is used to determine which bundle version we have ('*-i18n')
     * @param path
     * @returns {*|boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    isV2(path) {
      return path && REGEXP_V2.test(path);
    }


    /**
     * load all bundles, and map a map of name - to - string map
     * @returns {Promise<BundlesModel>}
     */
    load() {
      if (!this.loadPromise) {
        const promises = this.bundleDefinitions.filter((bundle) => bundle.isAllowed())
          .map((bundle) => bundle.load(this.runtimeEnvironment));

        this.loadPromise = Promise.all(promises)
          .then((bundles) => {
          // for the set of definitions, map a 'master' map of bundle name -> bundle strings
            bundles.forEach((bundle) => {
              this.bundleMap[bundle.name] = bundle.map;
            });
            return this;
          });
      }

      return this.loadPromise;
    }


    /**
     * @returns {{}}
     */
    getStringMap() {
      return this.bundleMap;
    }
  }

  return BundlesModel;
});

